<template>
  <div
    ref="mobilenav"
    :class="computedClass"
    class="bottom-0 mt-auto z-20 fixed bg-white rounded-t-xl left-0 right-0"
    style="padding: 1px env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)"
  >
    <nav class="flex flex-row justify-around">
      <HomeLink class="flex flex-col justify-center items-center text-gray-600 transform h-[52px] w-full" />
      <CatalogLink class="flex flex-col justify-center items-center text-gray-600 transform h-[52px] w-full" />
      <OrderLink class="flex flex-col justify-center items-center text-gray-600 transform h-[52px] w-full" />
      <MessageLink class="flex flex-col justify-center items-center text-gray-600 transform h-[52px] w-full" />
      <ProfileLink class="flex flex-col justify-center items-center text-gray-600 transform h-[52px] w-full" />
    </nav>
  </div>
</template>

<script>
import CatalogLink from '~/components/bottom_nav/catalog_link.vue'
import HomeLink from '~/components/bottom_nav/home_link.vue'
import MessageLink from '~/components/bottom_nav/message_link.vue'
import OrderLink from '~/components/bottom_nav/order_link.vue'
import ProfileLink from '~/components/bottom_nav/profile_link.vue'
export default {
  name: 'MobileNav',
  components: {
    HomeLink,
    CatalogLink,
    ProfileLink,
    OrderLink,
    MessageLink,
  },
  setup () {
    const { city } = useSearchForm()
    return {
      asOwnerMessages: useUser().asOwnerMessages,
      asRenterMessages: useUser().asRenterMessages,
      city,
      whoami: useOrder().whoami,
    }
  },
  computed: {
    computedClass () {
      return this.$route.path.includes('/orders/') ? 'hidden' : ''
    },
    computedHomeClass () {
      return this.$route.path.split('/').length === 2 ? 'active' : ''
    },
  },
  mounted () {
    useGlobal().setMobileNavHeight(
      this.$refs.mobilenav?.clientHeight,
    )
  },
}
</script>
